export interface Article {
  slug: string;
  categorySlug: string;
  title: string;
  excerpt: string;
  content: string;
  publishDate: string;
  readTime: number;
}

export const articles: Article[] = [
  {
    slug: 'yandex-daily-contest-full-rules-2025',
    categorySlug: 'competition-rules',
    title: 'Yandex每日大赛2025赛季完整规则详解',
    excerpt: '全面解读2025年度Yandex每日大赛官方规则、评分机制、参赛资格和注意事项，助你在赛场上游刃有余。',
    content: `<h2>一、赛事概述</h2>
<p>Yandex每日大赛是由Yandex竞技平台主办的全球性在线竞技赛事，自2020年首次举办以来，已吸引来自全球超过200个国家和地区的数百万玩家参与。2025赛季在赛制、评分和奖励方面进行了全面升级，为参赛者提供更加公平、有趣的竞技体验。</p>
<h2>二、参赛资格</h2>
<p>凡年满18周岁的Yandex注册用户均可报名参加每日大赛。参赛者需确保账户信息真实有效，每个用户每天仅限参加一次赛事。使用多账户刷分等违规行为一经发现将永久取消参赛资格。</p>
<h2>三、比赛时间</h2>
<p>每日大赛于北京时间<b>每日上午10:00开启报名</b>，<b>下午14:00正式开始比赛</b>。每场比赛时长约为60分钟，具体结束时间视参赛人数而定。节假日照常举行，不受影响。</p>
<h2>四、评分机制</h2>
<p>2025赛季采用全新的五维评分体系：</p>
<ul><li><strong>速度得分（25%）：</strong>完成任务的时间效率</li><li><strong>准确度得分（30%）：</strong>答案的正确率</li><li><strong>创意得分（20%）：</strong>解决方案的创新性</li><li><strong>稳定性得分（15%）：</strong>全程表现的波动程度</li><li><strong>互动得分（10%）：</strong>与平台其他功能的互动活跃度</li></ul>
<h2>五、违规处理</h2>
<p>严禁使用外挂程序、脚本自动化、团队协作作弊等行为。平台配备先进的AI检测系统，违规者将被给予以下处罚：首次警告扣分、二次禁赛7天、三次永久封禁。</p>`,
    publishDate: '2025-03-15',
    readTime: 8,
  },
  {
    slug: 'yandex-contest-registration-step-by-step',
    categorySlug: 'registration-guide',
    title: '2025最新Yandex每日大赛报名流程全攻略',
    excerpt: '从零开始，详细图解Yandex每日大赛官网注册、实名认证到报名参赛的完整操作步骤，新手也能轻松上手。',
    content: `<h2>一、访问官方入口</h2>
<p>打开Yandex每日大赛官网，在首页右上角点击"注册"按钮。建议使用Chrome或Yandex浏览器以获得最佳体验。请务必通过官方网站入口访问，避免钓鱼网站风险。</p>
<h2>二、创建Yandex账户</h2>
<p>填写基本信息：用户名（支持中文）、手机号码（中国大陆用户请使用+86号码）、电子邮箱、设置登录密码（需包含大小写字母和数字，至少8位）。</p>
<h2>三、实名认证</h2>
<p>为确保比赛公平性，所有参赛者必须完成实名认证。上传本人有效身份证件照片，系统将在1个工作日内完成审核。审核通过后将发送短信通知。</p>
<h2>四、绑定支付方式</h2>
<p>奖励将通过绑定的支付方式发放，支持银行卡、支付宝、微信支付。请确保绑定的账户归属人与实名认证信息一致。</p>
<h2>五、首次报名参赛</h2>
<p>完成以上步骤后，在每日大赛页面点击"立即报名"，选择参赛时段，确认参赛协议即可完成报名。报名成功后您将收到参赛编号，请妥善保管。</p>`,
    publishDate: '2025-04-02',
    readTime: 6,
  },
  {
    slug: 'yandex-contest-rewards-breakdown',
    categorySlug: 'reward-info',
    title: 'Yandex每日大赛奖励体系全面解析：从日常奖励到年度大奖',
    excerpt: '深度解读Yandex每日大赛多层次奖励机制，包括每日排名奖励、周冠奖励、月度王者奖励和年度总决赛大奖。',
    content: `<h2>一、每日排名奖励</h2>
<p>每日大赛结束后，根据最终排名发放奖励：</p>
<ul><li><strong>第1名：</strong>奖金500元 + 1000积分 + 金色荣誉勋章</li><li><strong>第2-5名：</strong>奖金200元 + 500积分 + 银色荣誉勋章</li><li><strong>第6-20名：</strong>奖金50元 + 200积分 + 铜色荣誉勋章</li><li><strong>第21-100名：</strong>100积分 + 参与纪念徽章</li></ul>
<h2>二、周冠军奖励</h2>
<p>每周积分累计排名第一的选手获得"周冠军"称号，额外奖励2000元现金和3000积分。连续四周获得周冠军将解锁"月度战神"特效头像框。</p>
<h2>三、月度王者奖励</h2>
<p>每月评选一次"月度王者"，综合当月所有比赛表现。奖品包括：iPhone最新款手机、5000元现金大奖、月度王者专属皮肤（永久）。</p>
<h2>四、年度总决赛</h2>
<p>每年12月举行年度总决赛，全年积分前100名选手自动获得参赛资格。总冠军奖金高达<b>10万元人民币</b>，并获得Yandex官方认证"年度竞技大师"称号。</p>`,
    publishDate: '2025-05-10',
    readTime: 7,
  },
  {
    slug: 'yandex-contest-new-season-updates',
    categorySlug: 'event-news',
    title: '重磅！Yandex每日大赛2025夏季赛季全新改版公告',
    excerpt: '2025夏季赛季迎来重大更新：新赛制、新界面、新奖励，更有神秘联动活动等你来探索。',
    content: `<h2>一、赛季改版概述</h2>
<p>2025年6月1日起，Yandex每日大赛将迎来史上最大规模改版。本次改版综合了百万用户反馈意见，从赛制设计、界面交互到奖励体系进行全面优化升级。</p>
<h2>二、新赛制亮点</h2>
<p>引入"挑战者模式"：选手可选择挑战排名高于自己的对手，挑战成功可获得额外积分加成。每场比赛增加3道隐藏加分题，答对可获得额外20%的分数加成。</p>
<h2>三、界面全新升级</h2>
<p>比赛界面全面重新设计，支持暗黑模式和自定义主题。新增实时数据面板，可随时查看个人排名变化趋势、题目正确率统计等详细数据。</p>
<h2>四、联动活动预告</h2>
<p>夏季赛季期间，Yandex每日大赛将与多家知名品牌展开联动合作，参赛者有机会赢取限量联名周边和专属奖励。具体合作品牌将于6月中旬公布，敬请期待！</p>`,
    publishDate: '2025-05-28',
    readTime: 5,
  },
  {
    slug: 'yandex-contest-beginner-tips',
    categorySlug: 'beginner-guide',
    title: 'Yandex每日大赛新手入门必看：从青铜到王者的进阶之路',
    excerpt: '专为新手打造的Yandex每日大赛全方位攻略，包括赛前准备、答题技巧、时间管理策略和常见误区避坑指南。',
    content: `<h2>一、赛前准备</h2>
<p>1. 确保网络连接稳定，建议使用有线网络或5GHz WiFi。2. 提前10分钟登录平台，检查设备运行状态。3. 准备好计算器和草稿纸。4. 关闭无关应用程序以保证系统性能。</p>
<h2>二、核心答题技巧</h2>
<p><strong>先易后难策略：</strong>快速浏览所有题目，优先完成简单题目，再回头攻克难题。<strong>时间管理：</strong>每题平均分配时间不超过3分钟，遇到难题果断标记后跳过。<strong>善用排除法：</strong>对于选择题，先排除明显错误选项可大幅提升正确率。</p>
<h2>三、常见误区避坑</h2>
<p>新手最容易犯的错误：盲目追求速度忽视准确度（准确度占比30%！）、不仔细阅读题目要求、忽视互动得分的重要性、轻信网络上的"必过攻略"。记住：稳扎稳打才是制胜之道。</p>
<h2>四、进阶提升策略</h2>
<p>分析每场比赛的数据报告，找出自身薄弱环节。参加社区讨论学习高手经验，建立个人错题本定期复习。坚持每日参赛，经验值的积累是无可替代的。</p>`,
    publishDate: '2025-06-01',
    readTime: 9,
  },
  {
    slug: 'yandex-contest-scoring-details',
    categorySlug: 'competition-rules',
    title: 'Yandex每日大赛五维评分体系深入解读',
    excerpt: '详细剖析Yandex每日大赛2025赛季新版五维评分体系的每个维度的计算方式和提升策略。',
    content: `<h2>一、速度得分（25%）</h2>
<p>速度得分根据完成任务的时间效率进行排名计算。在所有参赛者中，完成时间越短排名越高。系统采用分段计分方式，前10%选手获得满分25分，10%-30%获得20分，以此类推。建议在保证准确度的前提下提升速度。</p>
<h2>二、准确度得分（30%）</h2>
<p>准确度是权重最高的维度。每道题目有独立的正确性判定，部分题目支持部分得分。注意：提交后不可修改答案，请确认无误后再提交。</p>
<h2>三、创意得分（20%）</h2>
<p>创意得分由AI系统自动评估解决方案的创新性。使用独特方法解题、展示多元思维都能获得更高评分。但需注意创新必须以正确为前提，偏离题目要求的创新不得分。</p>
<h2>四、稳定性得分（15%）</h2>
<p>稳定性评估选手在整个赛程中的表现波动。全程保持稳定的选手将获得更高分数，忽高忽低的表现会被扣分。这鼓励选手合理安排节奏，保持专注。</p>
<h2>五、互动得分（10%）</h2>
<p>包括赛前热身题、赛间互动活动、赛后反馈问卷等环节的参与情况。积极参与平台各类互动可获得额外加分，这也是拉开差距的重要途径。</p>`,
    publishDate: '2025-06-15',
    readTime: 10,
  },
  {
    slug: 'yandex-contest-payment-setup',
    categorySlug: 'registration-guide',
    title: 'Yandex每日大赛支付方式绑定与奖励提现完整教程',
    excerpt: '详解Yandex每日大赛支持的所有支付方式绑定流程，以及奖励提现的操作步骤、到账时间和常见问题。',
    content: `<h2>一、支持的支付方式</h2>
<p>Yandex每日大赛目前支持以下支付方式：银行卡（支持国内主流银行）、支付宝、微信支付。国际用户支持PayPal和国际信用卡支付。</p>
<h2>二、绑定流程</h2>
<p>登录账户后进入"我的钱包"页面，点击"添加支付方式"，选择您的支付类型并填写相关信息。系统会进行小额验证（0.01元），验证通过后即可使用。</p>
<h2>三、奖励提现规则</h2>
<p>单次提现金额最低10元，每日提现上限5000元。奖金到账时间：支付宝/微信实时到账，银行卡1-3个工作日。积分不可提现，仅可在积分商城兑换商品。</p>
<h2>四、常见问题</h2>
<p>Q：为什么提现失败？A：请检查支付账户实名信息是否与Yandex账户一致。Q：奖励有有效期吗？A：现金奖励永久有效，积分每年12月31日清零。Q：可以更改绑定支付方式吗？A：可以，每月可更改一次。</p>`,
    publishDate: '2025-07-01',
    readTime: 5,
  },
  {
    slug: 'yandex-contest-annual-championship-2024',
    categorySlug: 'event-news',
    title: '2024年度总决赛精彩回顾：冠军的荣耀时刻',
    excerpt: '回顾2024年度Yandex每日大赛总决赛的精彩瞬间，冠军选手的夺冠历程和感言，以及2025赛季展望。',
    content: `<h2>一、赛事回顾</h2>
<p>2024年度Yandex每日大赛总决赛于12月20日在线上盛大举行。来自全球的100位顶尖选手经过激烈角逐，最终角逐出年度总冠军、亚军和季军。</p>
<h2>二、冠军风采</h2>
<p>来自中国的选手"星辰大海"以总分985分的绝对优势夺得年度总冠军。他在赛后接受采访时表示："坚持每日参赛，持续学习和进步是成功的关键。"</p>
<h2>三、奖金详情</h2>
<p>2024年度总决赛总奖金池达到50万元人民币，冠军独揽10万元大奖。所有入围总决赛的选手均获得不低于1000元的参赛奖金。</p>
<h2>四、2025展望</h2>
<p>2025赛季已全面升级，更多精彩赛事和丰厚奖励等待着你。无论你是资深玩家还是新手小白，每日大赛都为你准备了专属的竞技舞台。</p>`,
    publishDate: '2025-07-15',
    readTime: 6,
  },
  {
    slug: 'yandex-contest-advanced-strategies',
    categorySlug: 'beginner-guide',
    title: 'Yandex每日大赛高手进阶策略：如何稳定进入前20名',
    excerpt: '分析Yandex每日大赛排名前20选手的共同特征和核心策略，从题库研究到心理调节的全方位提升指南。',
    content: `<h2>一、题库研究法</h2>
<p>Yandex每日大赛的题目存在一定的模式规律。建议记录每日题目类型和解题思路，建立个人题库。通过分析3-6个月的题目数据，可以发现出题倾向和热门考点。</p>
<h2>二、时间分配策略</h2>
<p>顶级选手的时间分配：前10分钟快速完成50%的简单题，中间30分钟攻克中等难度题，最后20分钟处理难题和复查。切勿在前几题过度纠结。</p>
<h2>三、心理素质训练</h2>
<p>比赛中的心理状态直接影响发挥。建议赛前进行5分钟深呼吸冥想，赛中保持平和心态。遇到连续答错的题不要慌乱，冷静切换到下一题。</p>
<h2>四、数据分析工具</h2>
<p>善用平台提供的数据分析功能，每周复盘自己的表现数据。重点关注：正确率趋势、各题型得分率、时间分配效率，针对薄弱环节制定专项提升计划。</p>`,
    publishDate: '2025-07-28',
    readTime: 8,
  },
  {
    slug: 'yandex-contest-faq-official',
    categorySlug: 'competition-rules',
    title: 'Yandex每日大赛官方常见问题解答汇总',
    excerpt: '整理了Yandex每日大赛参赛者最常提问的50个问题，涵盖报名、规则、奖励、技术问题等各个方面。',
    content: `<h2>一、报名相关问题</h2>
<p><strong>Q：报名需要费用吗？</strong>A：完全免费，Yandex每日大赛不收取任何报名费用。</p>
<p><strong>Q：可以用同一个手机号注册多个账户吗？</strong>A：不可以，一个手机号只能绑定一个账户，多账户参赛属于违规行为。</p>
<p><strong>Q：注册后可以修改用户名吗？</strong>A：用户名每月可修改一次，但修改后历史成绩不受影响。</p>
<h2>二、比赛相关问题</h2>
<p><strong>Q：错过了报名时间怎么办？</strong>A：每日报名截止时间为13:30，错过当日报名可等待次日10:00新一轮报名开启。</p>
<p><strong>Q：比赛中途可以退出重来吗？</strong>A：不可以，比赛一旦开始不可暂停或重新开始。</p>
<h2>三、技术问题</h2>
<p><strong>Q：比赛中断网了怎么办？</strong>A：系统会自动保存当前进度，3分钟内恢复连接可继续参赛。超过3分钟则视为弃权。</p>
<h2>四、奖励问题</h2>
<p><strong>Q：奖励什么时候发放？</strong>A：每日奖励在比赛结束后2小时内到账，周奖和月奖在评选结果公布后24小时内发放。</p>`,
    publishDate: '2025-08-01',
    readTime: 6,
  },
];